(() => {
  if (typeof window.customElements.get('site-switcher') !== 'undefined') { return }
  window.customElements.define('site-switcher', class SiteSwitcher extends HTMLElement {
    constructor () {
      super()

      this.dropdownEl = this.querySelector('[data-site-switcher-dropdown]')

      this.initSiteSwitcher()
    }

    initSiteSwitcher () {
      try {
        this.initSwitcherDropdown()
      } catch (error) {
        console.error('There was an issue with the Site Switcher section:', error)
      }
    }

    initSwitcherDropdown () {
      if (!this.dropdownEl) { return }

      this.dropdownEl.addEventListener('change', () => {
        window.location.href = this.dropdownEl.value
      })
    }
  })
})()
